import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageURL } from 'router/pageURL';

export const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(PageURL.APPLICATIONS);
  }, []);

  return (
    <div>
      <h3>Home</h3>
    </div>
  );
};
